import { notification } from 'antd';
import { useEffect } from 'react';
import { socketService } from '../../services/socket';

export const NotificationHandler = () => {
  useEffect(() => {
    console.log('NotificationHandler mounted');
    
    const handleNotification = (data: {
      content: string;
      notification_type: 'success' | 'info' | 'warning' | 'error';
    }) => {
      console.log('Handling notification:', data);
      notification[data.notification_type]({
        message: '系统通知',
        description: data.content,
        placement: 'topRight',
        duration: 4.5,
      });
    };

    socketService.on('notification', handleNotification);
    console.log('Notification event handler registered');

    return () => {
      console.log('NotificationHandler unmounting');
      socketService.off('notification', handleNotification);
    };
  }, []);

  return null;
};

export default NotificationHandler; 